import { useUserAuth } from '~/components/Auth';
import { isImpersonatedSession } from '~/components/GlobalHeader/Learner/utils';

export const useImpersonation = (): boolean => {
  const auth = useUserAuth();
  return isImpersonatedSession(auth) || false;
};
